import { createTheme } from '@material-ui/core/styles';

export const config = {
  showTitle: false,
  pageSize: 10,
  search: false,
  sorting: true,
  tableLayout: 'auto',
  maxBodyHeight: 'calc(100vh - 140px)',

};

export const localization = translate => ({
  pagination: {
    labelDisplayedRows: '{from}-{to} of {count}',
    labelRowsSelect: translate('common:Rows'),
  },
  toolbar: {
    nRowsSelected: '{0} row(s) selected',
  },
  header: {
    actions: translate('common:Edit'),
  },
  body: {
    emptyDataSourceMessage: translate('indicators:no_records_to_display'),
    filterRow: {
      filterTooltip: 'Filter',
    },
  },
});

export const theme = createTheme({
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '.table-wrapper div div div::-webkit-scrollbar': {
          height: '12px',
          width: '12px',
          '-webkit-appearance': 'auto',
        },
        '.table-wrapper div div div::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          borderRadius: '6px',
        },
        '.table-wrapper div div div::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },

        '.table-wrapper div div div': {
          scrollbarWidth: 'auto',
          scrollbarColor: 'rgba(0, 0, 0, 0.5) transparent',
        },
      },
    },
    MuiTableCell: {
      root: {
        padding: '4px 5px',
        whiteSpace: 'nowrap',
      },
    },
    MuiPaper: {
      elevation2: {
        boxShadow: 'none',
      },
    },
    MuiIconButton: {
      root: {
        padding: 0,
      },
    },
  },
});
